import Decorator from './decorator'
import { join, filter, trim } from 'lodash'

export default class LocationDecorator extends Decorator {
  /**
   * Get the locations address based on the parts provided.
   *
   * @return string
   */
  address () {
    let address = join(filter([
      this.decorated.street_name,
      this.decorated.suburb,
      this.decorated.short_state
    ]), ', ')

    if (this.decorated.street_number) {
      address = `${this.decorated.street_number} ${address}`
    }

    return address
  }

  /**
   * Determine if the location is favourited.
   *
   * @return boolean
   */
  favourite () {
    return this.decorated.favourited_count === 1
  }

  hoursOfLoading () {
    if (!this.decorated.hours_of_loading) {
      return '–'
    }

    return this.decorated.hours_of_loading
  }

  directions () {
    if (!this.decorated.directions) {
      return '–'
    }

    return this.decorated.directions
  }

  formattedName () {
    return this.suburb
      ? trim(`${this.name} ${this.suburb}`)
      : this.name
  }

  nameWithShortState () {
    const name = this.suburb
      ? this.suburb
      : this.name

    return this.decorated.short_state
      ? `${name}, ${this.decorated.short_state}`
      : name
  }
}



// WEBPACK FOOTER //
// ./src/decorators/location.js